<template>
    <div class="roleMenuManagement">
        <breadcrumb class="breadcrumb"/>
        <el-row class="main-container">
          <el-col :span="10" class="roleLeft">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>用户列表</span>
              </div>
              <div>
                <el-row class="interfaceOption">
                  <el-col :span="10">
                    <el-input v-model.trim="interfaceSearch" placeholder="请输入用户名" clearable
                              prefix-icon="el-icon-search"
                              size="small"
                              @keyup.enter.native="search"></el-input>
                  </el-col>

                  <el-col :offset="1" :span="13" >
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                  </el-col>
                </el-row>

                <div style="margin-top: 15px;height: 460px;overflow-y: auto">
                  <el-table
                    :data="userData"
                    style="width: 100%;min-height: 460px"
                    v-loading="userLoad" :stripe="true" :border="true"
                    :row-style="{cursor:'pointer'}"
                    highlight-current-row @current-change="portListChange">
                    <el-table-column
                      type="index"
                      label="序号"
                      width="50">
                    </el-table-column>
                    <el-table-column
                      prop="userName"
                      label="用户名">
                    </el-table-column>
                    <el-table-column
                      prop="role"
                      width="80"
                      label="角色">
                    </el-table-column>
                    <el-table-column
                      prop="remarks"
                      label="描述">
                    </el-table-column>
                    <el-table-column
                      prop="date"
                      label="创建时间"
                    width="180">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 5px">
              <div slot="header" class="clearfix">
                <span>用户信息</span>
              </div>
              <div>
                <el-form ref="roleForms" :model="roleForm" label-width="100px" :rules="roleRules" :inline="true" size="small">
                  <el-form-item label="用户名称：">
                    <el-input v-model="roleForm.userName"></el-input>
                  </el-form-item>
                  <el-form-item label="角色：">
                    <el-input v-model="roleForm.role"></el-input>
                  </el-form-item>
                </el-form>
                <el-form :model="roleForm" label-width="100px" size="small">
                  <el-form-item label="角色描述：">
                    <el-input v-model="roleForm.remarks"></el-input>
                  </el-form-item>
                </el-form>
                <div class="buttonGroup">
                  <el-button type="success" size="small" icon="el-icon-plus" @click="addUser">新增</el-button>
                  <el-button type="warning" size="small" icon="el-icon-edit" @click="modifyUser">保存</el-button>
                  <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteUser">删除</el-button>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="14" class="roleRight">
             <div class="roleRightTop">
               <el-card class="box-card">
                 <div slot="header" class="clearfix">
                   <span>选中菜单</span>
                 </div>
                 <div class="tagBox">
                   <el-tag
                     :key="key"
                     v-for="(list,key) in selectMenuData"
                     closable
                     :disable-transitions="false"
                     @close="closeTag(key)"
                    style="margin: 0 15px 15px 0">
                     {{list.menuName}}
                   </el-tag>
                 </div>
               </el-card>
             </div>

             <div class="roleRightBottom">
               <el-card class="box-card" style="height: 607px;overflow-y: auto">
                 <div slot="header" class="clearfix">
                   <span>所有菜单</span>
                 </div>
                 <div class="treeBox" v-loading="arrLoad">
                   <el-tree :data="treeData" :props="treeProps" :highlight-current="true" style="min-height: 420px" show-checkbox @check-change="checkChange" :default-expand-all="true" ref="tree" @check="checkTree" node-key="ID">
                   </el-tree>
                 </div>
               </el-card>
             </div>
          </el-col>
        </el-row>
    </div>
</template>

<script>
  import moment from 'moment'
    export default {
        data() {
          let validateUserName = (rule, value, callback)=>{
            if(!value){
              return callback(new Error('用户名不能为空'));
            }else{
              callback();
            }
          }
            return {
              userData:[],
              userLoad:true,
              selectMenuData:[],
              interfaceSearch:'',
              menuTotal:0,
              arrLoad:true,
              roleForm:{remarks:'',userName:'',role:'',ID:'',},
              treeData:[],
              clickTree:{},
              selectBool:false,
              treeResult:[],
              treeProps:{
                children: 'childMenus',
                label: 'menuName',
              },
              roleRules:{
                userName:[ { validator: validateUserName, trigger: 'blur',required: true }],
              }
            };
        },
        mounted() {
          this.init();
        },
        methods: {
          async init(){
            await this.queryAllParentMenus();
            await this.queryUsers();
          },
          //获取所有菜单
          async queryAllParentMenus(){
            let vm =this;
            await vm.axios.get("/common/queryAllMenus", )
              .then((res)=> {
                vm.arrLoad = false;
                vm.treeData = res.data.allMenus;
              })
          },
          //获取所有用户
          queryUsers(){
            let vm = this;
            vm.axios.get("/common/queryUsers",{params:{userName: vm.interfaceSearch}})
              .then((res)=> {
              vm.userLoad = false;
                vm.userData = res.data.userList;
                vm.userData.forEach((val)=>{
                  val.date = moment(val.createDate).utc(0).format('YYYY-MM-DD HH:mm:ss')
                })
              })
          },
          //新增用户
          addUser(){
            let vm =this;
            for(let key in vm.roleForm){
              vm.roleForm[key] = ''
            }
            vm.recursiveEmpty(vm.treeData);
          },
          //保存用户
          modifyUser(){
            let vm =this;
            vm.$refs.roleForms.validate((val)=>{
              if(val){
                let selected = vm.$refs.tree.getCheckedNodes();
                let halfChecked = vm.$refs.tree.getHalfCheckedNodes();
                let selectResult = [];
                if(selected.length===0&&halfChecked.length===0){
                  vm.$message.error('您还未选择任何一项菜单');
                }else{
                  if(selected.length>0){
                    selected.forEach((val)=>{
                      selectResult.push(val.ID);
                    })
                  }
                  if(halfChecked.length>0){
                    halfChecked.forEach((val)=>{
                      selectResult.push(val.ID);
                    })
                  }
                  let params = {
                    userName:vm.roleForm.userName,
                    role:vm.roleForm.role,
                    menuIds:selectResult,
                    remarks:vm.roleForm.remarks,
                  }
                  if(vm.roleForm.ID !== ''){
                    params.ID = vm.roleForm.ID;
                    vm.axios.post("/common/modifyUser", {params:params})
                      .then((res)=> {
                        console.log(res)
                        if(res.data.resultCode === '00'){
                          vm.addUser();
                          vm.$message({
                            type: 'success',
                            message: '修改用户成功!'
                          });
                          vm.init();
                        }else{
                          vm.$message({
                            type: 'error',
                            message: res.data.message,
                          });
                        }
                      })
                  }else{
                    vm.axios.post("/common/saveUser", {params:params})
                      .then((res)=> {
                        console.log(res)
                        if(res.data.resultCode === '00'){
                          vm.addUser();
                          vm.$message({
                            type: 'success',
                            message: '新建用户成功!'
                          });
                          vm.init();
                        }else{
                          vm.$message({
                            type: 'error',
                            message: res.data.message,
                          });
                        }
                      })
                  }
                }
              }
            })
          },
          //删除用户
          deleteUser(){
            let vm =this;
            if(vm.roleForm.ID === ''){
              vm.$message.error('请选择一个用户！');
            }else{
              vm.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let params = {
                  ID:vm.roleForm.ID
                }
                vm.axios.post("/common/deleteUser", {params: params})
                  .then((res)=> {
                    if(res.data.resultCode === '00'){
                      vm.addUser();
                      vm.$message({
                        type: 'success',
                        message: '删除成功!'
                      });
                      vm.init();
                    }
                  })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            }
          },
          //保存选中项目
          /*recursiveSave(arr,arrAll){
            let vm =this;
            let arrResult = [];
            for(let i=0;i<arrAll.length;i++){
              if(arrAll[i].childMenus && arrAll[i].childMenus.length>0){
              }else{
                for(let j=0;j<arr.length;j++){
                  if(arrAll[i].ID === arr[j].ID){
                    if(arrResult.indexOf(arr[j].ID) === -1){
                      arrResult.push(arr[j].ID);
                    }
                  }
                }
                continue;
              }
            }
            return arrResult;
          },*/
          //当表格的当前行发生变化的时候会触发该事件
          portListChange(currentRow, oldCurrentRow){
            let vm =this;
            if(currentRow){
              vm.roleForm = {
                userName:currentRow.userName || '',
                role:currentRow.role || '',
                remarks:currentRow.remarks || '',
                ID:currentRow.ID,
              }
              vm.recursiveEmpty(vm.treeData);
              let params = {
                userID:currentRow.ID
              }
              vm.axios.get("/common/queryUserMenus", {params: params})
                .then((res)=> {
                  console.log(res.data)
                  if(res.data.menus.length>0){
                    res.data.menus.forEach((val,index)=>{
                      vm.recursiveTable(val,vm.treeData,);
                    })
                  }
                })
            }
          },
          //表格的当前行发生变化的递归
          recursiveTable(item,arr){
            let vm =this;
            for(let i=0;i<arr.length;i++){
              if(arr[i].childMenus){
                vm.recursiveTable(item,arr[i].childMenus);
              }else{
                if(item.ID === arr[i].ID){
                  vm.$refs.tree.setChecked(item.ID,true,false);
                }
              }
            }
          },
          //递归函数
          recursive(item,arr,bool){
            let vm =this;
            if(bool){
              for(let i=0;i<arr.length;i++){
                if(arr[i].ID === item.ID){
                  vm.$refs.tree.setChecked(item.ID,true,true);
                 // console.log(111)
                  continue;
                }
                if(!arr[i].childMenus){
                  continue;
                }else{
                  vm.recursive(item,arr[i].childMenus,bool);
                }
              }
            }else{
              for(let i=0;i<arr.length;i++){
                if(arr[i].ID === item.ID){
                  vm.$refs.tree.setChecked(item.ID,false,true);
                  continue;
                }
                if(!arr[i].childMenus){
                  continue;
                }else{
                  vm.recursive(item,arr[i].childMenus);
                }
              }
            }
          },
          recursiveEmpty(arr){
            let vm =this;
            for(let i=0;i<arr.length;i++){
              vm.$refs.tree.setChecked(arr[i].ID,false,true);
              if(!arr[i].childMenus){
                continue;
              }else{
                vm.recursiveEmpty(arr[i].childMenus);
              }
            }
          },
          //节点选中状态发生变化时的回调
          checkChange(obj,bool,node){
            let vm = this;
           // console.log(obj)
            if(bool){
              vm.selectBool = false;
              let sub = 0
              vm.selectMenuData.forEach((val)=>{
                if(val.ID !== obj.ID){
                  sub++
                }
              })
              if(sub === vm.selectMenuData.length){
                vm.selectMenuData.push(obj);
              }
            }else{
              vm.selectBool = true;
              //vm.recursive(obj,vm.treeData,0);
              vm.selectMenuData.forEach((val,index)=>{
                if(val.ID === obj.ID){
                  vm.selectMenuData.splice(index,1)
                }
              })
              event.stopPropagation();
              /*for(let i=0;i<vm.selectMenuData.length;i++){

              }
              vm.selectMenuData.forEach((val,index)=>{
                  vm.selectMenuData.splice(index,1)
              })*/
            }
          },
          //tag标签取消选中事件
          closeTag(index){
            let vm =this;
            //console.log(vm.selectMenuData[index])
            vm.recursive(vm.selectMenuData[index],vm.treeData,0);
            vm.selectMenuData.splice(index,1);
          },
          //加载子树数据的方法
          loadSecondary(node,resolve){
            //console.log(node)
            //console.log(resolve)
            let vm = this;
            vm.axios.get("/common/queryChildMenuByParentId", {params: {parentMenuId: node.data.ID}})
              .then((res)=> {
              //console.log(res.data.childMenus)
                if(res.data.childMenus){
                  resolve(res.data.childMenus);
                }
              })
          },
          //节点被点击时触发
          checkTree(obj){
            let vm =this;
            if(vm.selectBool){
              vm.recursive(obj,vm.treeData,0);
            }
          },

          // 条件查询
          search() {
            let vm = this;

            vm.queryUsers();
          },
        },
      watch:{
        /*selectMenuData(val){
          let vm = this;
          console.log(val);
        },*/
      }
    }
</script>

<style scoped lang="scss">
  .roleMenuManagement{
    .roleLeft{
        .buttonGroup{
          padding-left: 15px;
          display: flex;
          justify-content: flex-start;
      }
    }
    .roleRight{
      padding-left: 5px;
      .roleRightTop{
        .tagBox{
          height: 100px;
          overflow-y: auto;
        }
      }
      .roleRightBottom{
        margin-top: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/management/loginMenuManagement.vue